import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Grid } from '@mui/material'
import React, { useEffect, useMemo } from 'react'
import { Controller, useForm } from 'react-hook-form';
import InputSelectFieldGrid from '../common/InputSelectFieldGrid';
import { createReportLayoutService, getReportLayoutService, updateReportLayoutService } from '../../services/report/reportService';
import { useState } from 'react';
import InputTextFieldGrid from '../common/InputTextFieldGrid';
import CustomButton from 'components/CustomButton';
import Image from 'components/common/Image';
import Images from 'assets/images';
import theme, { backgroundColor } from 'config/theme';
import { borderColor } from '@mui/system';

const ColumnFilterModal = ({
  open,
  report,
  columns,
  selected,
  layout,
  onSuccess = () => { },
  onClose = () => { }
}) => {
  const [layouts, setLayouts] = useState(null)
  const { control, handleSubmit, setValue, watch, reset } = useForm({
    defaultValues: {
      layout: layout?.id,
      name: layout?.name,
      ...columns.reduce((acc, column) => ({ ...acc, [column.name]: selected.includes(column.name) }), {}),
      // ...selected.reduce((a, v) => ({ ...a, [v]: true }), {})
    }
  });
  
  useEffect(() => {
    if (open) {
      reset(columns.reduce((acc, column) => ({ ...acc, [column.name]: selected.includes(column.name) }), {}))
      getReportLayoutService(report).then((layouts) => {
        setLayouts(layouts)
      })
    }
    // eslint-disable-next-line
  }, [open]);

  const list = useMemo(() => columns.reduce((prev, current) => {
    if (prev[current.category]) {
      prev[current.category].push(current)
    } else {
      prev[current.category] = [current]
    }
    return prev;
  }, {}), [columns]);


  const submit = (result) => {
    delete result.layout;
    delete result.name;
    onSuccess(Object.entries(result).filter(([, value]) => value).map(([key]) => key))
  };

  const save = async () => {
    const { layout, name } = watch();
    const data = watch();
    delete data.layout;
    delete data.name;
    const selectedColumns = Object.entries(data).filter(([, value]) => value).map(([key]) => key);
    let result;
    if (layout) {
      result = await updateReportLayoutService(layout, {
        name,
        fields: selectedColumns
      })
    } else {
      result = await createReportLayoutService(report, {
        name,
        fields: selectedColumns
      })
    }
    getReportLayoutService(report).then((layouts) => {
      setValue('layout', result.id);
      setLayouts(layouts)
    })
    // onSuccess(selectedColumns);
  }

  const handlerClose = () => {
    onClose();
  }

  const handlerSelectLayout = (id) => {
    const layout = layouts.find(item => item.id === id);
    setValue('name', layout?.name || '');
    columns.forEach((column) => {
      setValue(column.name, layout?.fields?.includes(column.name) || false);
    });
  }

  return (
    <Dialog
      open={open}
      onClose={handlerClose}
      fullWidth={true}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '16px',
          width: '700px',
          maxWidth: '700px',
        }
      }}
    >
      <>
        <DialogTitle
          textAlign={'center'}
          fontWeight={'bold'}
        >
          Selecciona las columnas
        </DialogTitle>
        <DialogContent >
          <Grid container gap={1} pt={1} mb={4} direction={'row'} wrap='nowrap'>
            <InputSelectFieldGrid
              key={'layout'}
              xs={6}
              control={control}
              name={'layout'}
              label={'Plantilla'}
              data={[
                { id: '', name: 'Nueva' },
                ...(layouts || []).map(({ id, name }) => ({ id, name }))
              ]}

              onSelect={handlerSelectLayout}
              loading={layouts === null}
            />
            <InputTextFieldGrid
              key={'name'}
              xs={6}
              name={'name'}
              control={control}
              label={'Nombre'}
            />
          </Grid>
          <FormGroup>
            <Grid container>
              {
                Object.entries(list).map(([category, columns], key) => (
                  <Grid container key={key} mb={1} >
                    {
                      category != 'undefined' &&
                      <Grid item xs={12} mb={2} flexDirection={'row'} display={'flex'} gap={1}>
                        <span style={{ fontWeight: 'bold', fontSize: '16px', color: theme.contrastColor }}>{category}</span>
                        <Box flex={1} borderBottom={2} borderColor={theme.contrastColor} />
                      </Grid>
                    }
                    {
                      columns.map(({ name, label }, key) => (
                        <Grid item xs={3} key={key} mb={2}>
                          <Controller
                            name={name}
                            control={control}
                            render={({
                              field: { value, onChange },
                            }) => (
                              <FormControlLabel
                                label={label}
                                sx={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                                control={
                                  <Checkbox
                                    id={`column_filter_${name}`}
                                    checkedIcon={<Image src={Images.icon.check_square} />}
                                    icon={<Image src={Images.icon.uncheck_square} />}
                                    checked={value}
                                    value={value}
                                    onChange={onChange}
                                    size='small'
                                    sx={{ padding: 0, marginLeft: 1, marginRight: 1 }}
                                  />
                                } />
                            )}
                          />
                        </Grid>
                      ))
                    }
                  </Grid>
                ))
              }
            </Grid>
          </FormGroup>
        </DialogContent>
        <DialogActions sx={{ padding: '24px 16px' }}>
          <CustomButton
            click={save}
            name={"Guardar Plantilla"}
            disabled={!watch('name')}
            sx={{
              marginRight: 'auto',
            }}
          />
          <CustomButton
            click={handlerClose}
            name={"Cancelar"}
            sx={{
              backgroundColor: '#F29496',
              borderColor: '#F29496'
            }}
          />
          <CustomButton
            id='columnAccept'
            click={handleSubmit(submit)}
            name={"Buscar"}
          />
        </DialogActions>
      </>
    </Dialog >
  )
}

export default ColumnFilterModal